/* src/app/features/assets/components/asset-grid/asset-grid.scss */
:host {
  display: block;
}
.grid-track.fixed {
  display: flex;
  flex-flow: row wrap;
  row-gap: 20px;
}
.grid-track.fluid {
  display: grid;
  grid-template-columns: repeat(var(--cols, 1), minmax(0, 1fr));
  gap: 20px;
}
/*# sourceMappingURL=asset-grid.css.map */
